import React from 'react';
import Footer from '../Footer';
import Header from '../Header';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

export default function Team() {
  return (
    <>
      <Header />
      <div>
        <p className="bg-gradient-to-r from-dark to-gray-400 w-full p-16 text-center font-RaleRegular text-light text-3xl md:py-36 md:pb-20">
          Team
        </p>
        <div className="bg-darkbgDefault">
          <Swiper
            breakpoints={{
              // when window width is >= 640px
              100: {
                slidesPerView: 1
              },
              600: {
                slidesPerView: 3
              }
            }}
            slidesPerView={3}
            spaceBetween={30}
            slidesPerGroup={1}
            loop={true}
            loopFillGroupWithBlank={true}
            navigation={true}
            modules={[Navigation, Autoplay, Pagination]}
            autoplay={{
              delay: 6000,
              disableOnInteraction: true
            }}
            className="pt-5">
            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/ketan.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Ketan Bhansali
                  </p>
                  <p className="text-dark capitalize font-RaleSemiBold text-sm">
                    Labour Law Consultant & Advisor
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/karan.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Karan Bhansali
                  </p>
                  <p className="text-dark capitalize font-RaleSemiBold text-sm">
                    Advocate, High Court
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/raveen.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Raveen Palekar
                  </p>
                  <p className="text-dark capitalize font-RaleSemiBold text-sm">
                    Advocate, High Court
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/prapti.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Prapti Bhadra
                  </p>
                  <p className="text-dark capitalize font-RaleSemiBold text-sm">
                    Advocate, High Court
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/yash.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Yash Thadeshwar
                  </p>
                  <p className="text-dark capitalize font-RaleSemiBold text-sm">
                    Advocate, High Court
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/vipul.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Vipul Bhatt
                  </p>
                  <p className="text-dark capitalize font-RaleSemiBold text-sm">IPR Consultant</p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/harsh.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Harsh Mehta
                  </p>
                  <p className="text-dark capitalize font-RaleSemiBold text-sm">
                    Company Secretary
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/sanjay.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Sanjay Trivedi
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/sambhaji.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Sambhaji Gavare
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/sachin.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Sachin Shetye
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/vishal.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Vishal Rasalkar
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="flex flex-col m-auto  mb-5 items-center w-72 teamdiv">
                <img
                  src={require('../../../assets/images/pradeep.jpg')}
                  className="h-[250px] mt-4 grayscale hover:filter-none"
                />
                <div className="px-6 text-center">
                  <p className="text-black capitalize font-RaleSemiBold text-xl mt-2">
                    Pradeep Panchal
                  </p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      <Footer />
    </>
  );
}
